import PropTypes from 'prop-types';

import LoanTermSelector from '../LoanTermSelector';
import OfferDetailsSection from '../OfferDetailsSection';

import './index.scss';

const LoanTerm = ({
  explanationOpen,
  offerOptions,
  selectedOffer,
  onSelectedOfferChange,
  applicationId,
  customerGuid,
  cosignerSelection,
  offerAccepted,
}) => {
  const handleSelectedOfferChange = offer => {
    onSelectedOfferChange(offer);
  };

  const explanationText = (
    <>
      How long do you plan to take to repay the loan? This refers to the repayment period that
      begins after your study period and grace period ends.
    </>
  );

  return (
    <OfferDetailsSection
      className="loan-term"
      explanationOpen={true}
      title="Loan term"
      explanationText={explanationText}
      hasExpanded={false}
    >
      <LoanTermSelector
        applicationId={applicationId}
        customerGuid={customerGuid}
        offerOptions={offerOptions}
        selectedOffer={selectedOffer}
        onSelectedOfferChange={handleSelectedOfferChange}
        cosignerSelection={cosignerSelection}
        offerAccepted={offerAccepted}
      />
    </OfferDetailsSection>
  );
};

LoanTerm.propTypes = {
  explanationOpen: PropTypes.bool.isRequired,
  offerOptions: PropTypes.arrayOf(
    PropTypes.shape({
      offer_guid: PropTypes.string.isRequired,
      term_in_months: PropTypes.number.isRequired,
      monthly_repayment: PropTypes.string.isRequired,
      loan_type: PropTypes.string.isRequired,
    }),
  ).isRequired,
  selectedOffer: PropTypes.shape({
    offer_guid: PropTypes.string.isRequired,
  }).isRequired,
  onSelectedOfferChange: PropTypes.func.isRequired,
  applicationId: PropTypes.string.isRequired,
  customerGuid: PropTypes.string.isRequired,
  cosignerSelection: PropTypes.string.isRequired,
  offerAccepted: PropTypes.bool.isRequired,
};

export default LoanTerm;
